export interface SortableListViewProps {
  children: React.ReactNode;
}

export const SortableListView = ({ children }: SortableListViewProps) => (
  <div className="flex h-10 items-center gap-1">{children}</div>
);
